export default class ManageFirm {
  constructor() {
    this.firm = {};
    this.firmOffices = {};
    this.custodians = [];
    this.repCodes = [];
  }
}
